
/// <summary name='cafm' type='Object'>Container object for CAFM code</summary>
let cafm = {
    /// <field name='readyBegin' type='Array'>Contains functions to be called at the beginning of $(document).ready</field>
    readyBegin: [],
    /// <field name='readyEnd' type='Array'>Contains functions to be called at the end of $(document).ready</field>
    readyEnd: [],
    /// <field name='loadBegin' type='Array'>Contains functions to be called at the beginning of $(window).load</field>
    loadBegin: [],
    /// <field name='loadEnd' type='Array'>Contains functions to be called at the end of $(window).load</field>
    loadEnd: [],
    /// <field name='ajaxBegin' type='Array'>Script to run just after an AJAX request has completed</field>
    ajaxBegin: [],
    /// <field name='ajaxEnd' type='Array'>Script to run after an AJAX request has completed and subsequent cafm.views script has run</field>
    ajaxEnd: [],
    /// <field name='_currentModule' type='cafm.enums.CAFMModuleEnum'>The current module the user is using, defaults to None</field>
    _currentModule: null,
    /// <field name='_lastServerActivity' type='Number'>The numer of milliseconds since 1970 for when the client last accessed the CAFM web server</field>
    _lastServerActivity: null,
    /// <field name='_clientSettings' type='Object'>CAFM client settings object</field>
    _clientSettings: null,
    /// <field name='_isOffline' type='Object'>CAFM is offline flag</field>
    _isOffline: null,
    setCurrentModule: function (m) {
        /// <summary>Sets the current module the user is using</summary>
        /// <param name="m" type="cafm.enums.CAFMModuleEnum">The current module</param>

        this._currentModule = m;
    },
    getCurrentModule: function () {
        /// <summary>Gets the current module the user is using - that was set using cafm.setCurrentModule(m)</summary>
        /// <returns type="cafm.enums.CAFMModuleEnum">The current module in use</returns>

        return this._currentModule ? this._currentModule : cafm.enums.CAFMModuleEnum.None;
    },
    setClientSettings: function (cs) {

        if (!this._clientSettings) { // if no existing then just set

            this._clientSettings = cs;
        }
        else { // otherwise merge as some settings require authentication, and because of offline we want to keep them

            $.extend(this._clientSettings, cs); // merge properties if we already have some
        }
    },
    getClientSettings: function () {

        var cs = this._clientSettings;

        if (!cs) {

            cs = cafm.cache.get(cafm.res.consts.CacheKey_ClientSettings);
        }

        return cs;
    },
    isMobile: function () {

        return document.getElementsByTagName('body')[0].className.match(new RegExp('(\\s|^)mobile(\\s|$)'));
    }
};

export { cafm as default }